import React, { useEffect, useState } from "react";
import { TransactionBadge } from "../../components/TransactionBadge";
import { Arrow, CardPay, SwapArrow } from "../../components/svg/Wallet/Wallet";
import { BiChevronDown } from "react-icons/bi";
import dayjs from "dayjs";
import { Card } from "../../components/Card";
import { useFundWallet } from "../../api/fundWallet";
import { Loader } from "../../components/loader/Loader";
import { FilterDropdown } from "../../components/filterDropdown";
import clsx from "clsx";

const filters = [
  {
    key: "All Time",
    value: "alltime",
  },
  {
    key: "Monthly",
    value: "monthly",
  },
  {
    key: "Weekly",
    value: "weekly",
  },
  {
    key: "Daily",
    value: "daily",
  },
];

export const Transactions = () => {
  const [type, setType] = useState(filters[0]);
  const { getTransactionHistory, transactionHistory, loadingHistory } =
    useFundWallet();

  useEffect(() => {
    getTransactionHistory(type.value);
  }, [type]);
  return (
    <div className="pb-3">
      <div className="flex items-center justify-between gap-5 ">
        <h3 className="text-xl font-bold text-black">Transactions</h3>
        <div className="flex items-center gap-3">
          <p className="text-sm font-medium text-[#00000080]">Filters:</p>
          <FilterDropdown
            options={filters}
            selectedOption={type}
            setSelectedOption={setType}
            selectedOptionClass={clsx(
              "rmc_select_selected !rounded-none",
              type?.value ? "bg-[#2741d6] !text-white" : "",
            )}
            selectedClass="bg-white !text-black"
            dropdownClass="rmc_select_dropdown text-xs !bg-white"
            optionsClass="rmc_select_options !text-black hover:bg-[#2741d6] hover:!text-[#ffff]"
            trailingIcon={
              <BiChevronDown
                size={16}
                className="text-[#0000004D] transition-transform duration-200"
              />
            }
          />
        </div>
      </div>

      <Card className="my-5 overflow-y-scroll hidden-scrollbar max-h-[40vh]">
        <div className="flex flex-col gap-5">
          {loadingHistory ? (
            <div className="flex justify-center items-center h-[30vh] flex-col gap-3">
              <div className="grid place-self-center h-full">
                <Loader type="spinningBubbles" color="#2741d6" />
              </div>
            </div>
          ) : transactionHistory.length === 0 ? (
            <div className="flex justify-center items-center h-[40vh] flex-col gap-3">
              <p className="tracking-tighter text-2xl font-semibold text-black mx-0 text-center">
                No Transaction History
              </p>
              <p className="text-sm font-medium mt-1 text-black w-full max-w-[300px] text-center">
                Once you fund your wallet, your transaction history will show up
                here.
              </p>
            </div>
          ) : (
            transactionHistory.map((x, i) => {
              return (
                <div
                  key={i}
                  className="flex justify-between items-center  gap-5 cursor-pointer "
                >
                  <div className="flex items-center gap-2.5">
                    <div className="rounded-[5px] bg-[#ECEFFF] mx-auto p-1.5">
                      {x.payment_method === "card" ? (
                        <CardPay />
                      ) : x.payment_method === "swap" ? (
                        <SwapArrow />
                      ) : (
                        <Arrow
                          className={
                            x.is_credit === 1 ? "-rotate-90" : " rotate-90"
                          }
                          fill="#2741D6"
                        />
                      )}
                    </div>
                    <div className="flex flex-col">
                      <p className="leading-tight mb-1 text-sm text-primary-black font-medium hover:underline">
                        {x.payment_method === "card"
                          ? "Card payment"
                          : "Transfer Payment"}
                      </p>
                      <span className="text-xs font-semibold text-[#00000099]">
                        ref: {x.payment_reference}
                      </span>
                      <span className="text-xs text-[#00000099] font-light">
                        {dayjs(x.created_at).format("D MMM YYYY h:mm A")}
                      </span>
                    </div>
                  </div>
                  <div>
                    <p className="leading-tight text-nowrap mb-1 text-sm text-primary-black font-medium">
                      {x.amount}
                    </p>
                    <TransactionBadge status={x.status} />
                  </div>
                </div>
              );
            })
          )}
        </div>
      </Card>
    </div>
  );
};
